// src/layouts/products/components/ProductDetailsView/VersionHistoryTab.js
import React, { useMemo } from 'react';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import ArgonBox from 'components/ArgonBox';
import ArgonTypography from 'components/ArgonTypography';

function VersionHistoryTab({ product, allProducts }) {
  const versionHistoryData = useMemo(() => {
    if (!allProducts || !product) {
      return [];
    }
    // Ensure product.groupedById exists before filtering
    return product.groupedById ? allProducts.filter((p) => p.groupedById === product.groupedById) : [];
  }, [allProducts, product]);

  if (!product) return null;

  return (
    <ArgonBox p={3}>
      {versionHistoryData.length > 0 ? (
        <TableContainer component={Paper}>
          <Table aria-label="version history table">
            <TableHead sx={{ display: 'contents' }}>
              {' '}
              {/* Consider if 'contents' is best or standard TableHead styling */}
              <TableRow>
                <TableCell>
                  <ArgonTypography variant="subtitle2" color="secondary">
                    Created By
                  </ArgonTypography>
                </TableCell>
                <TableCell>
                  <ArgonTypography variant="subtitle2" color="secondary">
                    Created Date
                  </ArgonTypography>
                </TableCell>
                <TableCell>
                  <ArgonTypography variant="subtitle2" color="secondary">
                    Product Version
                  </ArgonTypography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {versionHistoryData.map((version, index) => (
                <TableRow key={version.id || index}>
                  {' '}
                  {/* Ensure unique key */}
                  <TableCell>
                    <ArgonTypography variant="body2">{version.user?.email || 'N/A'}</ArgonTypography>
                  </TableCell>
                  <TableCell>
                    <ArgonTypography variant="body2">{new Date(version.created_date).toLocaleString()}</ArgonTypography>
                  </TableCell>
                  <TableCell>
                    <ArgonTypography variant="body2">{version.product_version || 'N/A'}</ArgonTypography>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <ArgonTypography variant="body2" color="textSecondary">
          No version history available for this product.
        </ArgonTypography>
      )}
    </ArgonBox>
  );
}

export default VersionHistoryTab;
